import React, { Component } from 'react';

import { Card, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';
import CustomTimePicker from '../elements/CustomTimePicker';

import moment from 'moment';

import Util from '../../Util';
import Config from '../../conf';
import Calendar from 'rc-calendar';
import 'rc-calendar/assets/index.css';

import { WashDetails as styles } from './form.css';

const washTypes = Config.WASH_TYPES;

class TimeSlots extends Component {

  constructor(props) {
    super(props);

    this.state = {
      timeDialogOpen: false,
      timeMessage: '',
    }

    this.shouldDisableDate = this.shouldDisableDate.bind(this);
    this.getTimeSlots = this.getTimeSlots.bind(this);

    this.fieldChanged = this.fieldChanged.bind(this);
    this.updateDate = this.updateDate.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.findAvailableTimes = this.findAvailableTimes.bind(this);
  }

  componentDidMount() {
    this.getTimeSlots();
  }

  fieldChanged(fieldName, newValue, callBack) {
    this.props.setHasError(fieldName, false);
    this.props.updateField(fieldName, newValue, callBack);
  }

  shouldDisableDate(date) {
    const minDate = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
    const maxDate = minDate.clone().add(1, 'week').add(1, 'day');

    const momentDate = moment(date);

    let valid = true;

    if (momentDate.isBefore(minDate)) valid = false;
    if (momentDate.isAfter(maxDate)) valid = false;
    //if (momentDate.clone().format('dddd') === 'Sunday' || momentDate.clone().format('dddd') === 'Saturday') valid = false;

    // Should disable date ie. if it is valid then it should not be disabled
    return !valid;
  }


  nextDisabled() {
    let ret = !this.props.details.date ||
      !this.props.details.startTime;

    return ret;
  }

  findAvailableTimes() {
    const date = this.props.details.date;
    let availableTimes;
    let result = false;
    const timeSlot = this.state.timeSlot;
    if (!timeSlot)
      return result;
    
    Object.keys(timeSlot).forEach((day) => {
      if (timeSlot[day].date == date) {
        availableTimes = timeSlot[day].avail;
        result = true;
      }
    })
    this.setState({
      times: availableTimes
    });
    return result;
  }

  getTimeSlots() {
    const date = this.props.details.date;
    if (!date)
      return;  
    if (this.findAvailableTimes())
      return;  
    const washType = this.props.details.washType.toUpperCase();
    const client = Config.CLIENT_NAME;

    fetch(Config.BACKEND_API_URL + 'washerhome/available-slots/' + date + '?package=' + washType + '&aloctype=' + client, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (data && data.result && data.result[client]) {
        console.log(data.result[client]);
        this.setState({
          timeSlot: data.result[client]
        }, this.findAvailableTimes);
      } else {
        throw ('err')
      }
    }).catch((err) => {
      console.log('Failed to check booking start time', err);
      this.setState({
        times: {}
      });
    });
  }

  updateDate(fieldName, newValue) {
    if (!newValue || !newValue.format)
      return;
    const date = newValue.format('YYYY-MM-DD');
    this.fieldChanged('time', 'Select Time');
    this.fieldChanged('startTime', '');
    this.fieldChanged('endTime', '');
    this.fieldChanged(fieldName, date, this.getTimeSlots);
  }

  complete() {
    this.closeDialog();
    this.props.next();
  }

  hoursToTime(time) {
    if (!time)
      return;
    const minutes = time * 60;
    return moment().hours(0).minutes(minutes).seconds(0).format('HH:mm');
  }

  render() {
    return (
      <div style={styles.center}>
        <h2 style={styles.title}>Select Date and Time</h2>
        <div style={styles.flexContainer}>
          <Calendar
            disabledDate={this.shouldDisableDate}
            defaultValue={moment(this.props.details.date)}
            onSelect={(evt) => this.updateDate('date', evt)}
            showDateInput={false}
          />
          {this.state.times && this.state.times.length > 0 &&
            <div style={{ width: "500px" }}>
              {this.state.times.map((time) => {
                return (
                  <div
                    key={time}
                    style={{
                    backgroundColor: this.props.details.startTime == time ? "#d0f3a3" : "#fff",
                    padding: "10px",
                    margin: "5px",
                    borderRadius: "2px",
                    boxShadow: "0px 0px 3px #00000075",
                    width: "120px",
                    lineHeight: "35px",
                    display: "inline-block",
                    cursor: 'pointer',
                  }}
                    onClick={(evt) => this.fieldChanged('startTime', time)}
                  >
                    <span>{this.hoursToTime(time - 0.5)} ~ {this.hoursToTime(time + this.props.details.washDuration + 0.5)}</span>
                  </div>
                )
              })}
            </div>
          }
          {!this.state.times || this.state.times.length == 0 &&
            <div style={{ width: "500px" }}>
              Time not available
            </div>
          }
        </div>
        <RaisedButton style={styles.backButton}
          label="Back" primary={true} onClick={this.props.back} />
        <RaisedButton style={styles.backButton}
          disabled={this.nextDisabled()}  
          label="Next" primary={true} onClick={this.props.next} />
      </div>
    );
  }
}

export default TimeSlots;



// WEBPACK FOOTER //
// ./src/app/components/form/TimeSlots.js